import { SimCard, SimCardsInData, SimCardApi, SimCardStatus } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class SimCardService {
	constructor(private simCardApi: SimCardApi = new SimCardApi()) {}

	public async getSimCards(
		options?: any,
	): Promise<{ simCards?: SimCardsInData; errorMessage?: string }> {
		try {
			const response = await this.simCardApi.getSimCards(options);
			return { simCards: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, 'Failed to fetch SIM Cards');
		}
	}

	public async getSimCardById(
		id: number,
		options?: any,
	): Promise<{ simCard?: SimCard; errorMessage?: string }> {
		try {
			const response = await this.simCardApi.getSimCardById(id, options);
			return { simCard: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch SIM Card by id: ${id}`);
		}
	}

	public async getSimCardStatus(
		id: number,
		options?: any,
	): Promise<{ simCardStatus?: SimCardStatus; errorMessage?: string }> {
		try {
			const response = await this.simCardApi.getSimCardStatus(id, options);
			return { simCardStatus: response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch SIM Card status by id: ${id}`);
		}
	}
}
